import { render, staticRenderFns } from "./Artikelliste.vue?vue&type=template&id=8a275826&"
import script from "./Artikelliste.vue?vue&type=script&lang=js&"
export * from "./Artikelliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports